import Module from '../../../packages/helper/module/index'
import Api from '../../../packages/helper/api/index'
import request from '../../api/request'

export default new Module('user', new Api(request, {
  list: '/api/user/list',
  one: '/api/user/details',
  add: '/api/user/add',
  update: '/api/user/modify'
}))



// WEBPACK FOOTER //
// ./examples/store/modules/user.js